module.exports = __webpack_public_path__ + "static/media/picture1.bb3da972.png";